/** @jsxImportSource preact */
import type { ComponentChildren } from "preact";

import { FormButton } from "../form/form-button";
import {
  AlertIcon,
  LockIcon,
  MailIcon,
  RestartIcon,
  SearchIcon,
  ShieldCheckIcon,
  TriangleAlertIcon,
  UserIcon,
} from "../icons";
import type { WidgetTokens } from "../theme";

/** 卡片里按钮和状态图标用的图标名，由调用方按场景挑。 */
export type WidgetCardIcon =
  | "alert"
  | "lock"
  | "mail"
  | "retry"
  | "search"
  | "shield-check"
  | "triangle-alert"
  | "user";

export interface WidgetCardAction {
  /** 按钮前面的小图标。 */
  icon?: WidgetCardIcon;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  /**
   * primary 墨黑实心的主答案；secondary 白底胶囊；ghost 只有字。
   * 不给时第一个按钮是 primary，其余是 secondary，保证一张卡只有一个墨黑答案。
   */
  variant?: "primary" | "secondary" | "ghost";
}

export function CardIcon({
  icon,
  size,
}: {
  icon: WidgetCardIcon;
  size: number;
}): ComponentChildren {
  switch (icon) {
    case "alert":
      return <AlertIcon size={size} />;
    case "lock":
      return <LockIcon size={size} />;
    case "mail":
      return <MailIcon size={size} />;
    case "retry":
      return <RestartIcon size={size} />;
    case "search":
      return <SearchIcon size={size} />;
    case "shield-check":
      return <ShieldCheckIcon size={size} />;
    case "triangle-alert":
      return <TriangleAlertIcon size={size} />;
    case "user":
      return <UserIcon size={size} />;
  }
}

/** 一列整宽胶囊按钮，卡片底部的操作区。 */
export function CardActions({
  actions,
  tokens,
}: {
  actions: WidgetCardAction[];
  tokens: WidgetTokens;
}) {
  return (
    <>
      {actions.map((action, index) => (
        <FormButton
          disabled={action.disabled || !action.onClick}
          fullWidth
          key={action.label}
          onClick={action.onClick}
          tokens={tokens}
          variant={action.variant ?? (index === 0 ? "primary" : "secondary")}
        >
          {action.icon && <CardIcon icon={action.icon} size={14} />}
          {action.label}
        </FormButton>
      ))}
    </>
  );
}
